import vSelect from 'vue-select'
import { BPaginationNav, BPagination } from 'bootstrap-vue'
import fetchItems from '@/scripts/vue/api-axios'
import VueScrollTo from 'vue-scrollto'

const categoryId = typeof window.category_id === "undefined" ? 12 : window.category_id
const perPageInitial = typeof window.perPageInitial === "undefined" ? 4 : window.perPageInitial

const actionsDocumentsConfig = {
  components: {
    vSelect,
    BPaginationNav,
    BPagination
  },
  mounted() {
    // start loader
    this.$Progress.start();

    // get documents
    fetchItems(`/yiifdocuments?categoryId=${ categoryId }`)
      .then((documents) => {

        // sort document types
        this.dDocuments = documents.filter(document => {
          return document.type === 'D'
        });
        this.pDocuments = documents.filter(document => {
            return document.type === 'P'
        });

      })
      .then(() => {
          
        // get filters
        fetchItems(`/yiifdocuments/type?categoryId=${ categoryId }`)
          .then((filters) => {
            this.scrollTo('body', 0);

            // sort filter types
            this.dCategories = filters.filter(filter => {
                return filter.type === 'D'
            });
            this.pCategories = filters.filter(filter => {
                return filter.type === 'P'
            });

            // set the "Show All" option
            this.setShowAllOptions();

            // finish loader
            this.$Progress.finish();

          })

      });

  },
  data: () => ({
    dDocuments: [],
    pDocuments: [],

    dCategories: [],
    pCategories: [],

    dSelectedCategory: 0,
    pSelectedCategory: 0,

    dcurrentPage: 1,
    pcurrentPage: 1,

    dPerPage: perPageInitial,
    pPerPage: perPageInitial,

    scrollerIsScrolling: false
  }),
  computed: {
    dItemsForList(){
      return this.dFilteredItems
      /*.sort((a, b) => {
        // sort by date
        return this.$date(a.dateChange).isBefore(this.$date(b.dateChange)) ? 1 : -1
      })*/
      .slice(
        // slice per page
        (this.dcurrentPage - 1) * this.dPerPage,
        this.dcurrentPage * this.dPerPage,
      );
    },
    pItemsForList(){
      return this.pFilteredItems
      /*.sort((a, b) => {
        // sort by date
        return this.$date(a.dateChange).isBefore(this.$date(b.dateChange)) ? 1 : -1
      })*/
      .slice(
        // slice per page
        (this.pcurrentPage - 1) * this.pPerPage,
        this.pcurrentPage * this.pPerPage,
      );
    },

    dFilteredItems() {
        return this.dDocuments.filter(document => {
            if ( !this.dSelectedCategory ) return true;
            return document.documents_type_id == this.dSelectedCategory
        });
    },
    pFilteredItems() {
        return this.pDocuments.filter(document => {
            if ( !this.pSelectedCategory ) return true;
            return document.documents_type_id == this.pSelectedCategory
        });
    },

    dRows(){
      return this.dFilteredItems.length
    },
    pRows(){
      return this.pFilteredItems.length
    }
  },
  methods: {
      setShowAllOptions(){
        // dCategories Show all option
        if ( this.$refs.dCategorySelect?.placeholder )
        {
            // get placeholder from ref select
            const placeholder = this.$refs.dCategorySelect.placeholder;

            // fill clear option, append it as first element and select by default (id 0 is what makes it show all categories)
            const clearOption = {
                id: 0,
                name: placeholder,
                type: 'D'
            };

            this.dCategories.unshift(clearOption);
            this.dSelectedCategory = 0;
        }

        // pCategories Show all option
        if ( this.$refs.pCategorySelect?.placeholder )
        {
            // get placeholder from ref select
            const placeholder = this.$refs.pCategorySelect.placeholder;

            // fill clear option, append it as first element and select by default (id 0 is what makes it show all categories)
            const clearOption = {
                id: 0,
                name: placeholder,
                type: 'P'
            };

            this.pCategories.unshift(clearOption);
            this.pSelectedCategory = 0;
        }
      },
      scrollTo(target, duration, offset) {
        // if not scrolling already
        if ( !this.scrollerIsScrolling )
        {
          // scroll to target with desired duration
          VueScrollTo.scrollTo(target, {
            duration: duration,
            offset: offset,
            onStart: () => {
              // set scrolling variable
              this.scrollerIsScrolling = true;
            },
            onDone: () => {
              // unset scrolling variable
              this.scrollerIsScrolling = false;
            }
          });
        }
      },
      scrollToDownloads(){
        this.scrollTo('#documentsToDownload', 500, -100);
      },
      scrollToPresentations(){
        this.scrollTo('#documentsPresentations', 500, -100);
      }
  },
  watch: {
    dPerPage: function() {
      this.scrollToDownloads();
    },
    pPerPage: function() {
      this.scrollToPresentations();
    },

    dcurrentPage: function() {
      this.scrollToDownloads();
    },
    pcurrentPage: function() {
      this.scrollToPresentations();
    },

    dSelectedCategory: function (newValue, oldValue) {
      if ( oldValue != newValue ) {
        this.dcurrentPage = 1;
      }
    },
    pSelectedCategory: function (newValue, oldValue) {
      if ( oldValue != newValue ) {
        this.pcurrentPage = 1;
      }
    }
  }
}

export default actionsDocumentsConfig